<template>
  <div class="Container">
    <h3>Please select Trust to view Location Counts</h3>
    <div>
      <div class="Auto">
        <label for="autocompleteLocation">Trust: </label>
        <input
          type="text"
          autocomplete="off"
          v-model="location"
          @focus="modal = true"
        />
        <br />
        <div class="AutoDrop" v-if="filteredlocations && modal">
          <ul>
            <li
              v-for="(filteredlocation, idx) in filteredlocations"
              :key="idx"
              @click="setLocation(filteredlocation)"
            >
              {{ filteredlocation.toString() }}
            </li>
          </ul>
        </div>
        <br />
        <button class="button" v-on:click="submitLocation()">Filter</button>
        <button class="button" v-on:click="resetValue()">Clear</button>
      </div>
    </div>
    <div id="UnitRAG">
      <p>Current Unit Status Total:</p>
      <b-button-group>
        <b-button variant="danger" size="lg">{{
          this.GetButtonValue()
        }}</b-button>
        <b-button variant="warning" size="lg">{{
          this.GetButtonValue1()
        }}</b-button>
        <b-button variant="success" size="lg">{{
          this.GetButtonValue2()
        }}</b-button>
      </b-button-group>
      <br />
      <br />
    </div>
    <div class="Container">
      <b-container>
        <b-row>
          <b-col cols="12" md="12">
            <div class="Grid">
              <h4>Alarms</h4>
              <b-table
                id="Alarms"
                head-variant="dark"
                striped
                fixed
                show-empty
                empty-text="No Alarms for chosen trust"
                :items="this.AlarmItems"
                :fields="this.UserHeaders"
                :per-page="perPage"
                :current-page="currentPage"
                small
              ></b-table>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" md="12">
            <div class="Grid">
              <h4>Errors</h4>
              <b-table
                id="Errors"
                head-variant="dark"
                striped
                fixed
                show-empty
                empty-text="No Errors for chosen trust"
                :items="this.ErrorItems"
                :fields="this.UserHeaders"
                :per-page="perPage"
                :current-page="currentPage"
                small
              ></b-table>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" md="12">
            <div class="Grid">
              <h4>Support Requests</h4>
              <b-table
                id="Support"
                head-variant="dark"
                striped
                fixed
                show-empty
                empty-text="No Requests for chosen trust"
                :items="this.SupportItems"
                :fields="this.UserHeaders"
                :per-page="perPage"
                :current-page="currentPage"
                small
              ></b-table>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" md="12">
            <div class="Grid">
              <h4>Service Requests</h4>
              <b-table
                id="Service"
                head-variant="dark"
                striped
                fixed
                show-empty
                empty-text="No Requests for chosen trust"
                :items="this.ServiceItems"
                :fields="this.UserHeaders"
                :per-page="perPage"
                :current-page="currentPage"
                small
              ></b-table>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  components: {},

  data() {
    return {
      perPage: 10,
      currentPage: 1,
      AlarmItems: [],
      UserHeaders: [],
      ArrTest: [],
      ErrorHeaders: [],
      ErrorItems: [],
      SupportItems: [],
      SupportHeaders: [],
      ServiceItems: [],
      ServiceHeaders: [],
      location: "",
      locations: [],
      filteredlocations: [],
      modal: false,
      GreenCount: "--",
      AmberCount: "--",
      RedCount: "--",
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },

  async mounted() {
    let LookUpTrustUrl =
      "https://m59kpjvq25.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/locationsbytrust";
    let LookUpTrustHeaders = this.$apikeyPost;
    this.LookUpTrustRequest = {
      TrustName: "All",
    };
    axios
      .post(LookUpTrustUrl, this.LookUpTrustRequest, LookUpTrustHeaders)
      .then((response) => {
        this.locations = response.data.Values;
        this.info = response;
      });

    let DashdataUrl =
      "https://81vec86leg.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/agsdashboardcounts?RequestType=Load&Trust=";
    axios.get(DashdataUrl, { headers: this.$apikey }).then((response) => {
      this.testing = response.data.field_names;
      for (let i = 0; i < this.testing.length; i++) {
        var QuoteStr = "" + i + "";
        this.ArrTest.push({ key: QuoteStr, label: this.testing[i] });
      }
      this.UserHeaders = this.ArrTest;
      this.ArrTest = [];
      this.AlarmItems = response.data.Alarms;
      this.ErrorItems = response.data.Errors;
      this.SupportItems = response.data.Support;
      this.ServiceItems = response.data.Service;
    });

    let CountUrl =
      "https://81vec86leg.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/statuscounts";
    let CountHeaders = this.$apikeyPost;
    let CountData = { RequestType: "AGS", Trust: "All" };
    axios.post(CountUrl, CountData, CountHeaders).then((response) => {
      this.RedCount = response.data.Alarms[0][0];
      this.AmberCount = response.data.Errors[0][0];
      this.GreenCount = response.data.Active[0][0];
    });
  },

  methods: {
    resetValue: function() {
      this.location = "";
      this.modal = false;
      let DashdataUrl =
        "https://81vec86leg.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/agsdashboardcounts?RequestType=Load&Trust=";
      axios.get(DashdataUrl, { headers: this.$apikey }).then((response) => {
        this.testing = response.data.field_names;
        for (let i = 0; i < this.testing.length; i++) {
          var QuoteStr = "" + i + "";
          this.ArrTest.push({ key: QuoteStr, label: this.testing[i] });
        }
        this.UserHeaders = this.ArrTest;
        this.ArrTest = [];
        this.AlarmItems = response.data.Alarms;
        this.ErrorItems = response.data.Errors;
        this.SupportItems = response.data.Support;
        this.ServiceItems = response.data.Service;
      });

      let url =
        "https://m59kpjvq25.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/locationsbytrust?TrustName=All";
      axios.get(url, { headers: this.$apikey }).then((response) => {
        this.locations = response.data.Values;
        this.info = response;
      });
      this.RedCount = "--";
      this.AmberCount = "--";
      this.GreenCount = "--";
      let CountUrl =
        "https://81vec86leg.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/statuscounts";
      let CountHeaders = this.$apikeyPost;
      let CountData = { RequestType: "AGS", Trust: "All" };
      axios
        .post(CountUrl, CountData, CountHeaders)
        .then((response) => {
          this.RedCount = response.data.Alarms[0][0];
          this.AmberCount = response.data.Errors[0][0];
          this.GreenCount = response.data.Active[0][0];
        })
        .catch((err) => {
          return err;
        });
    },

    filterLocations: function() {
      if (this.location.length == 0) {
        this.filteredlocations = this.locations;
      }
      this.filteredlocations = this.locations.filter((location) => {
        return location
          .toString()
          .toLowerCase()
          .startsWith(this.location.toString().toLowerCase());
      });
    },

    GetButtonValue() {
      return this.RedCount;
    },

    GetButtonValue1() {
      return this.AmberCount;
    },

    GetButtonValue2() {
      return this.GreenCount;
    },

    submitLocation() {
      let FilterDataBase =
        "https://81vec86leg.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/agsdashboardcounts?RequestType=Filter&Trust=";
      let FilterTrust = this.location[0];
      let FilterUrl = FilterDataBase + FilterTrust;
      axios.get(FilterUrl, { headers: this.$apikey }).then((response) => {
        this.testing = response.data.field_names;
        for (let i = 0; i < this.testing.length; i++) {
          var QuoteStr = "" + i + "";
          this.ArrTest.push({ key: QuoteStr, label: this.testing[i] });
        }
        this.UserHeaders = this.ArrTest;
        this.ArrTest = [];
        this.AlarmItems = response.data.Alarms;
        this.ErrorItems = response.data.Errors;
        this.SupportItems = response.data.Support;
        this.ServiceItems = response.data.Service;
      });

      this.RedCount = "--";
      this.AmberCount = "--";
      this.GreenCount = "--";
      let CountUrl =
        "https://81vec86leg.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/statuscounts";
      let CountHeaders = this.$apikeyPost;
      let CountData = { RequestType: "AGS", Trust: this.location[0] };
      axios
        .post(CountUrl, CountData, CountHeaders)
        .then((response) => {
          this.RedCount = response.data.Alarms[0][0];
          this.AmberCount = response.data.Errors[0][0];
          this.GreenCount = response.data.Active[0][0];
        })
        .catch((err) => {
          return err;
        });
    },

    setLocation(location) {
      this.location = location;
      this.modal = false;
    },
  },

  watch: {
    location() {
      this.filterLocations();
    },
  },
};
</script>

<style scoped>
input[type="text"],
select {
  width: 60%;
  margin: 2px 0;
  border-style: solid;
  border-color: black;
  background-color: whitesmoke;
  padding: 2px 8px;
  position: relative;
  z-index: 1000;
}

.Grid > div {
  border: 1px solid black;
  border-radius: 5px;
  background-color: white;
  width: 100%;
}

table {
  color: aquamarine;
  font-size: 14px;
}

h4 {
  text-align: left;
  color: whitesmoke;
}
</style>
